var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-mml-xybox"},[(_vm.resp.data.Data && _vm.resp.data.Data[0])?_c('p',{staticStyle:{"padding":"0px","margin":"0px"}},[_vm._v("\n    "+_vm._s(_vm.getProcess(_vm.resp.data.Data[0].Progress)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }